import { render, staticRenderFns } from "./zdpopup.vue?vue&type=template&id=9f672c1a&scoped=true&"
import script from "./zdpopup.vue?vue&type=script&lang=js&"
export * from "./zdpopup.vue?vue&type=script&lang=js&"
import style0 from "./zdpopup.vue?vue&type=style&index=0&id=9f672c1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f672c1a",
  null
  
)

export default component.exports